import Button from "@material-ui/core/Button";
import MobileStepper from "@material-ui/core/MobileStepper";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import PropTypes from "prop-types";
import React from "react";
import Carousel from "../Carousel";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    display: "block",
    objectFit: "cover",
    width: "100%",
  },
}));

const ImageStepper = React.memo(function ImageStepper({
  steps = [],
  height = 320,
  width = 320,
  maxWidth = width,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = steps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <div className={classes.root} style={{ maxWidth }}>
      {Boolean(steps[activeStep]?.label) && (
        <Paper square elevation={0} className={classes.header}>
          <Typography variant="caption">{steps[activeStep].label}</Typography>
        </Paper>
      )}

      <Carousel
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        autoPlay
        interval={5000}
      >
        {steps.map((step, index) => (
          <div key={step.label || index}>
            {Math.abs(activeStep - index) <= 2 ? (
              <img
                className={classes.img}
                height={height}
                width={width}
                style={{ maxWidth }}
                src={step.imageUrl}
                alt={step.label}
              />
            ) : null}
          </div>
        ))}
      </Carousel>
      <MobileStepper
        steps={maxSteps}
        position="static"
        variant="text"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </div>
  );
});

ImageStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      imageUrl: PropTypes.string.isRequired,
    }),
  ),
};

export default ImageStepper;
